import { graphql } from "gql";

const UPLOAD_GROUP_THREAT_DOC_MUTATION = graphql(`
  mutation UploadThreatDoc(
    $description: String!
    $file: Upload!
    $groupName: String!
  ) {
    uploadThreatMatchDocument(
      description: $description
      file: $file
      groupName: $groupName
    ) {
      message
      success
    }
  }
`);

const LIST_GROUP_MATCH_DOCS = graphql(`
  query ListGroupMatchDocs($groupName: String!) {
    group(groupName: $groupName) {
      threatMatchDocs {
        description
        fileName
        modifiedBy
        modifiedDate
      }
    }
  }
`);

const GET_GROUP_THREAT_MATCHES = graphql(`
  query GetGroupThreatMatches($groupName: String!) {
    group(groupName: $groupName) {
      name
      threatMatches {
        edges {
          node {
            category
            original
            score
            title
            vulnType
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`);

const GET_GROUP_MATCHES_FINDINGS = graphql(`
  query GetGroupMatchesFindings($groupName: String!) {
    group(groupName: $groupName) {
      findings {
        id
        severityScoreV4
        title
        vulnerabilitiesSummaryV4 {
          closed
          open
        }
      }
    }
  }
`);

const GET_FA_DEFINES = graphql(`
  query GetFaDefinesVulns {
    criteriaConnection(after: "", first: 500) {
      edges {
        node {
          findingNumber
          en {
            title
          }
        }
      }
    }
  }
`);

const REMOVE_GROUP_THREAT_DOC_MUTATION = graphql(`
  mutation RemoveGroupThreatDoc($filename: String!, $groupName: String!) {
    removeMatchesDocument(filename: $filename, groupName: $groupName) {
      filename
      message
      success
    }
  }
`);

export {
  REMOVE_GROUP_THREAT_DOC_MUTATION,
  LIST_GROUP_MATCH_DOCS,
  UPLOAD_GROUP_THREAT_DOC_MUTATION,
  GET_GROUP_THREAT_MATCHES,
  GET_GROUP_MATCHES_FINDINGS,
  GET_FA_DEFINES,
};
